import React from 'react';
import type { MessageButton } from '../../../../types/chat-message';
import { ReportActionButtons } from './ReportActionButtons';
import './RevenueReport.scss';

const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('vi-VN').format(num);
};

const formatCurrency = (amount: number): string =>
  `${new Intl.NumberFormat('vi-VN').format(amount)}đ`;

export interface StockReportData {
  date?: string;
  reportType?: string;
  totalQuantity?: number;
  totalAmount?: number;
  totalOutOfStockQuantity?: number;
  totalCanSellQuantity?: number;
}

interface StockReportProps {
  data?: StockReportData;
  buttons?: MessageButton[];
  onButtonClick?: (name: string, id: number, isHidden?: boolean) => void;
  isLastMessage?: boolean;
  isFromHistory?: boolean;
  text?: string | null;
}

const MetricRow: React.FC<{ label: string; value: number | string; isHighlight?: boolean }> = ({
  label,
  value,
  isHighlight
}) => (
  <div className="rr-metric-row">
    <span className="rr-metric-label">{label}</span>
    <span className={`rr-metric-value ${isHighlight ? 'highlight' : ''}`}>
      {typeof value === 'number' && label.includes('Giá') ? formatCurrency(value) : value}
    </span>
  </div>
);

export const StockReport: React.FC<StockReportProps> = ({
  data,
  buttons,
  onButtonClick,
  isLastMessage,
  isFromHistory,
  text
}) => {
  const {
    date,
    totalQuantity = 0,
    totalAmount = 0,
    totalOutOfStockQuantity = 0,
    totalCanSellQuantity = 0,
  } = data ?? {};

  const isButtonDisabled = !isLastMessage || !!isFromHistory;

  return (
    <div className="revenue-report">
      <div className="rr-header">
        <span className="rr-title">{text || (date ? `BÁO CÁO KHO HÔM NAY ${date}` : 'BÁO CÁO KHO HÀNG')}</span>
      </div>

      <div className="rr-metrics">
        <MetricRow label="Số lượng" value={`${formatNumber(Math.floor(totalQuantity))}${totalQuantity % 1 !== 0 ? `,${Math.round((totalQuantity % 1) * 100)}` : ''} sản phẩm`} />
        <MetricRow label="Giá trị tồn" value={totalAmount} />
        <MetricRow label="Đã hết hàng" value={`${totalOutOfStockQuantity} sản phẩm`} />
        <MetricRow label="Sản phẩm còn bán" value={`${totalCanSellQuantity} sản phẩm`} />
      </div>

      <ReportActionButtons
        buttons={buttons}
        isDisabled={isButtonDisabled}
        onButtonClick={onButtonClick}
        reportType="Báo cáo kho hàng"
      />
    </div>
  );
};
